module.exports = __webpack_public_path__ + "img/undraw_cancel_u1it.8da17d35.svg";